import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCommentListing = createAsyncThunk(
  "commentListing/getCommentListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/comment/get_all_data`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const commentListingSlice = createSlice({
  name: "commentListing",
  initialState: {
    loading: false,
    commentListingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCommentListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommentListing.fulfilled, (state, action) => {
        state.loading = false;
        state.commentListingData = action.payload;
      })
      .addCase(getCommentListing.rejected, (state, action) => {
        state.loading = false;
        state.commentListingData = action.payload;
        state.error = action.payload;
      });
  },
});

export default commentListingSlice.reducer;
